export default __webpack_public_path__ + "static/media/logo_GMX_small_.f593fa5c.svg";